import { useState, useEffect, useContext } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { WorkflowsValue, WorkflowsDisbatch } from "../../../contexts/workflows";
import { TypesValue } from "../../../contexts/types";
import useStateTypes from "../../../utils/usestatetypes";
import Card from "./card";
import styles from "./styles.module.css";
import Editor from "./editor";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";
import { MdClose } from "react-icons/md";
export default function Workflows() {
  const { workflows, open, editor } = useContext(WorkflowsValue);
  const disbatch = useContext(WorkflowsDisbatch);
  const [selected, setSelected] = useState(null);
  const { appId, type, pageId } = useParams();
  const types = useContext(TypesValue);
  const stateTypes = useStateTypes();

  const handleClose = () => {
    setSelected(null);
    disbatch({ type: "setOpen", value: false });
  };

  useEffect(() => {
    if (workflows && selected) {
      Object.values(workflows).forEach((w) => {
        if (w.id === selected.id) setSelected(w);
      });
    }
  }, [workflows]);

  const handleAddWorkflow = () => {
    const workflow = {
      name: "New Workflow",
      custom: true,
      params: [],
      actions: [],
    };
    disbatch({
      type: "create",
      workflow,
      cb: (wf) => {
        setSelected(wf);
      },
    });
  };

  const handleDeleteWorkflow = () => {
    db.collection("apps")
      .doc(appId)
      .collection(type)
      .doc(pageId)
      .collection("workflows")
      .doc(selected.id)
      .delete();
    disbatch({ type: "delete", workflow: selected });
    setSelected(null);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <TypesValue.Provider value={[...types, ...stateTypes]}>
        <div
          className={
            open ? styles.backdrop + " " + styles.open : styles.backdrop
          }
          onClick={handleClose}
        >
          <div
            className={
              open ? styles.workflows + " " + styles.open : styles.workflows
            }
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                padding: "15px 15px 0px 15px",
              }}
            >
              <div className={styles.title}>Workflows</div>
              <MdClose className={styles.close} onClick={handleClose} />
            </div>
            <div style={{ display: "flex", flexGrow: 1 }}>
              <div style={{ width: 280, margin: 15 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div onClick={handleAddWorkflow} className={styles.addCustom}>
                    Add Reusable Workflow
                  </div>
                  {Object.values(workflows).map((w) => {
                    return (
                      <Card
                        selected={selected}
                        onClick={setSelected}
                        key={w.id}
                        workflow={w}
                      />
                    );
                  })}
                </div>
              </div>
              <Editor handleDelete={handleDeleteWorkflow} selected={selected} />
            </div>
          </div>
        </div>
      </TypesValue.Provider>
    </DndProvider>
  );
}
